import { useEffect } from "react";
import "./Notification.scss";

function Notification({ message, type = "success", duration = 4000, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`notification ${type}`}>
      <span className="material-symbols-outlined notification-icon">
        {type === "success" && "check_circle"}
        {type === "error" && "error"}
        {type === "info" && "info"}
        {type === "warning" && "warning"}
      </span>
      <span className="notification-message">{message}</span>
      <button className="notification-close" onClick={onClose}>
        <span className="material-symbols-outlined">close</span>
      </button>
    </div>
  );
}

export default Notification;
